/**
 * @generated SignedSource<<ef08d37eaa7d863644d965e9de900672>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATOrganizationStudentDeleteInput = {
  id: string;
  organization?: string | null;
};
export type OrganizationId_organizationStudentDeleteMutation$variables = {
  input: MATOrganizationStudentDeleteInput;
};
export type OrganizationId_organizationStudentDeleteMutation$data = {
  readonly organizationStudentDelete: {
    readonly id: string;
  };
};
export type OrganizationId_organizationStudentDeleteMutation = {
  response: OrganizationId_organizationStudentDeleteMutation$data;
  variables: OrganizationId_organizationStudentDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationId_organizationStudentDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MATStudent",
        "kind": "LinkedField",
        "name": "organizationStudentDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrganizationId_organizationStudentDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MATStudent",
        "kind": "LinkedField",
        "name": "organizationStudentDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5ce771aeaab4701c577190127593a1f",
    "id": null,
    "metadata": {},
    "name": "OrganizationId_organizationStudentDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrganizationId_organizationStudentDeleteMutation(\n  $input: MATOrganizationStudentDeleteInput!\n) {\n  organizationStudentDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b609d8bc85d94b245cabefb755f2c1f";

export default node;
